import get from 'lodash/get';
import head from 'lodash/head';
import isEqual from 'lodash/isEqual';
import { getCategoryIdByExternalId, getDemoUnitsForTestRide, getLinksForTestRide, getProductsForTestRide, } from '@yme/api';
import { SORT_PRODUCT_INDEX_ASC, VERSION_CAAS } from '@yme/common/constants';
import { ENABLED_FOR_TEST_RIDE_ATTR } from '@yme/common/selectors';
import { getCategoryIds } from '@yme/utils/categories';
import { getAttributeByName } from '@yme/utils/common';
import { SORT_PRODUCT_ABB_PRODUCT_NAME_LOCALIZED, SORT_PRODUCT_ASC } from './constants';
import { getEnableTestRideProducts, getFilteredByMasterSkuProducts, getMainModelForSelected, getMasterProductUniqueTestRideProducts, getPreparedCardsData, getProductsSkus, getTestRideEndpoint, } from './helpers';
export const getTestRideLinks = (currentPath, callback) => {
    getLinksForTestRide({
        currentPath,
    }).then((linksForForm) => {
        const linksArray = Object.entries(linksForForm ?? []).map(([key, value]) => ({
            key: parseInt(key, 10),
            value,
        }));
        callback((prev) => (isEqual(prev, linksArray) ? prev : linksArray));
    });
};
export const filterDemoUnits = ({ demoUnitsData, productsSKUs, masterVariationsData, allProductsData, }) => {
    const { productCodes, availableGenerationCodes } = demoUnitsData;
    const testRideProducts = [...new Set([...productCodes, ...availableGenerationCodes])];
    const masterData = getMainModelForSelected(testRideProducts, productsSKUs);
    const filteredProducts = getFilteredByMasterSkuProducts({
        allProductsData,
        testRideProducts,
        masterData,
    });
    const data = getPreparedCardsData({
        data: filteredProducts || [],
    });
    const masterVariationsCardsData = getPreparedCardsData({
        data: masterVariationsData,
    });
    const enableTestRideProducts = getEnableTestRideProducts(data);
    const testRideList = getMasterProductUniqueTestRideProducts(enableTestRideProducts, masterVariationsCardsData);
    return {
        testRideList,
        filteredProducts,
    };
};
export const getAllProductsData = ({ language, hyperdriveEndpoints, isLoadingCallback, isLoadedCallback, isErrorCallback, onSetTestRideCategoryId, setAllProductsDataCallback, }) => {
    let allProductsData = [];
    isLoadingCallback(true);
    getCategoryIdByExternalId({
        endpoint: hyperdriveEndpoints.categoryInfo,
    })
        .then((categoryIds) => {
        if (categoryIds.length) {
            const catId = get(head(categoryIds), 'id', '');
            onSetTestRideCategoryId(catId);
            const categoriesIdsParam = getCategoryIds(categoryIds);
            const parameters = {
                limit: 500,
                sortOrder: `${SORT_PRODUCT_INDEX_ASC}|${SORT_PRODUCT_ABB_PRODUCT_NAME_LOCALIZED}.${language}.${SORT_PRODUCT_ASC}`,
                version: VERSION_CAAS,
                testRide: true,
                isExternalId: true,
                includeArchived: true,
            };
            const endpoint = getTestRideEndpoint(hyperdriveEndpoints.generationProductsByQuery, categoriesIdsParam);
            return getProductsForTestRide({
                endpoint,
                config: {
                    ...parameters,
                },
            })
                .then((allProducts) => {
                allProductsData = allProducts?.results ?? [];
                setAllProductsDataCallback(allProductsData);
            })
                .catch(() => {
                isErrorCallback(true);
            });
        }
    })
        .catch(() => {
        isErrorCallback(true);
    })
        .finally(() => {
        isLoadingCallback(false);
        isLoadedCallback(true);
    });
};
export const getDemoUnitsSeparately = ({ isoCountryCode, isLoadingCallback, isLoadedCallback, isErrorCallback, setProductCallback, dealerIdList, projectKey, allProductsData, }) => {
    const productsSKUs = getProductsSkus(allProductsData);
    const masterVariationsData = allProductsData.filter((product) => product.groupingProducts.length);
    const productCodes = Object.keys(productsSKUs);
    isLoadingCallback(true);
    getDemoUnitsForTestRide({
        productCodes,
        isoCountryCode,
        projectKey,
        dealerIdList,
    })
        .then((response) => {
        const { testRideList, filteredProducts } = filterDemoUnits({
            demoUnitsData: response?.data,
            allProductsData,
            masterVariationsData,
            productsSKUs,
        });
        setProductCallback({
            cards: testRideList,
            products: filteredProducts.filter((product) => {
                return getAttributeByName(product.attributes, ENABLED_FOR_TEST_RIDE_ATTR);
            }),
        });
    })
        .catch(() => {
        isErrorCallback(true);
    })
        .finally(() => {
        isLoadingCallback(false);
        isLoadedCallback(true);
    });
};
